import { request } from '@langlois/request';

export async function edit ({ commit, getters }, competition) {
	try {
		const originalCompetition = getters[`getById`](competition.id);

		const patchCommands = [];

		Object.entries(competition).forEach(([key, value]) => {
			if (value === originalCompetition[key]) return;

			patchCommands.push({
				operation: `replace`,
				path: `/${key}/`,
				value
			});
		});

		const url = new URL(`${process.env.VUE_APP_API_URI}/club/competition/${competition.id}`);

		const response = await request.patch(url, patchCommands);

		if (response.ok) {
			commit(`setCompetition`, {
				...originalCompetition,
				...competition
			});
		}
	} catch (error) {
		return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while editing the competition.`,
			type: `warning`
		}, { root: true });
	}
}
